import {
    styled,
    KpiCard as KpiCardUi,
    KpiError as KpiErrorUi,
    KpiSkeleton as KpiSkeletonUi,
} from "@l2r-front/l2r-ui"

export const KpiSkeleton = styled(KpiSkeletonUi)(() => ({
    width: "100%",
    height: "100%",
}))

export const KpiError = styled(KpiErrorUi)(() => ({
    width: "100%",
    height: "260px !important",
    backroundColor: "blue",
}))

export const ChartContainer = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    height: "100%",
    marginTop: theme.spacing(6),
    width: "100%",
}))

export const KpiCard = styled(KpiCardUi)(() => ({
}))